import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import languageService from "../services/languageService";

export const getLanguages = createAsyncThunk("language/get", async () => {
  const res = await languageService.getLanguages();
  return res?.data;
});

const languageSlice = createSlice({
  name: "languages",
  initialState: {
    languages: [],
    languagesError: "",
  },
  extraReducers: (builder) => {
    //language list
    builder
      .addCase(getLanguages.pending, (state) => {
        state.loading = true;
      })
      .addCase(getLanguages.fulfilled, (state, action) => {
        state.loading = false;
        state.languages = action.payload;
      })
      .addCase(getLanguages.rejected, (state, action) => {
        state.loading = false;
        state.languagesError = action?.error;
      });
  },
});

export default languageSlice.reducer;
